import Api from '../_base';

class Order {
	async addOrder(data) {
		const response = await Api.post('/orders', data, true);

		return {
			data: response.data,
			status: response.status,
			statusText: response.statusText
		};
	}

	async updateOrder(data) {
		const response = await Api.put('/orders', data, true);

		return {
			data: response.data,
			status: response.status,
			statusText: response.statusText
		};
	}

	async getValue(orderId, paymentMethodPix) {
    try {
			let url = `/orders/value/${orderId}`;
			
			if (paymentMethodPix) {
					url += `/${paymentMethodPix}`;
			}

			const response = await Api.get(url, true);
			
			return {
				data: response.data,
				status: response.status,
				statusText: response.statusText
			};
    } catch (error) {
      throw error; 
    }
}

}

export default new Order();
